/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, March 3rd 2022, 9:13:38 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import ListItemText from "@mui/material/ListItemText";
import { AddNewFieldToolSet } from "form-builder/components/AddNewFieldToolSet";
import { AddNewBPMNNodeToolSet } from "service-builder/components/workflow-builder/AddNewBPMNNodeToolSet";
import React from "react";
import { SERVICE_BUILDER_RELATIVE_URLS } from "service-builder/routes";
import { useRouteMatch } from "core/routes/utils";

export type ServiceBuilderToolSet = "BPMN_TASKS_TOOL_SET" | "FORM_FIELDS_TOOL_SET";

export const ServiceBuilderToolBarItems = () => {
  const [selectedToolSet, setSelectedToolSet] = React.useState<ServiceBuilderToolSet>();

  const routeMatch = useRouteMatch(Object.values(SERVICE_BUILDER_RELATIVE_URLS));

  const currentRoute = routeMatch?.pattern?.path;

  let ToolSetComponent: React.ReactNode;
  let ToolSetTitle: string;

  switch (selectedToolSet) {
    case "BPMN_TASKS_TOOL_SET":
      ToolSetComponent = <AddNewBPMNNodeToolSet />;
      ToolSetTitle = "Drag to add a new step to this workflow";
      break;
    case "FORM_FIELDS_TOOL_SET":
      ToolSetComponent = <AddNewFieldToolSet />;
      ToolSetTitle = "Add a Field";
      break;
    default:
      ToolSetComponent = null;
  }

  React.useEffect(() => {
    switch (currentRoute) {
      case SERVICE_BUILDER_RELATIVE_URLS.serviceBuilderRoot:
        setSelectedToolSet("BPMN_TASKS_TOOL_SET");
        return;
      case SERVICE_BUILDER_RELATIVE_URLS.serviceFormBuilder:
        setSelectedToolSet("FORM_FIELDS_TOOL_SET");
        return;
      default:
        setSelectedToolSet(null);
    }
  }, [setSelectedToolSet, currentRoute]);

  return (
    ToolSetComponent && (
      <div className="os-services-toolbar-wrapper">
        <ListItemText
          className="os-services-toolbar-title"
          primary={ToolSetTitle}
          primaryTypographyProps={{
            fontSize: 15,
            color: "text.secondary",
            fontWeight: "medium",
            lineHeight: "20px",
            mb: "2px",
          }}
          sx={{
            px: 3,
            pt: 2.5,
            pb: 2.5,
          }}
        />
        <div className="os-services-toolbar-buttons">{ToolSetComponent}</div>
      </div>
    )
  );
};
